import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from 'tss-react/mui';
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-mui";
import LockIcon from "@mui/icons-material/Lock";
import { InputAdornment } from "@mui/material";
import EmergencyIcon from "@mui/icons-material/LocalHospitalOutlined";
import SettingsCard from "./settingsCard";

const useStyles = makeStyles()((theme) => ({
  root: {
    "& .MuiInputBase-root": {
      display: "flex",
      alignItems: "start",
      "& .MuiInputAdornment-root": {
        alignItems: "start",
      },
    },
  },
}));

const EmergencySettings = (props) => {
    const { classes } = useStyles();
    const { user } = props;

    const handleValidation = (values) => {
      const errors = {};

      return errors;
    };

    const handleSubmit = (values, { setSubmitting }) => {
        
    };

    return (
      <Formik
        initialValues={{
          location: user.emergency.location,
        }}
        validate={handleValidation}
        onSubmit={(values, setSubmitting) =>
          handleSubmit(values, setSubmitting)
        }
      >
        {() => (
          <Form onSubmit={(e) => e.preventDefault()} className={classes.root}>
            <SettingsCard
              icon={<EmergencyIcon />}
              title="Emergency location"
              hint="The location on file for emergency calls. It is managed by your administrator."
            >
              <Field
                variant="outlined"
                component={TextField}
                fullWidth
                disabled
                multiline
                rows={6}
                name="location"
                type="textArea"
                label="Location notes"
                placeholder="No location notes on file."
                slotProps={{ inputLabel: { shrink: true }, input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <LockIcon color="disabled" fontSize="small" />
                    </InputAdornment>
                  ),
                } }}
              />
            </SettingsCard>
          </Form>
        )}
      </Formik>
    );
};

EmergencySettings.propTypes = {
  user: PropTypes.object.isRequired,
};

export default EmergencySettings;
